<template lang="pug">
  .component-federation-add
    .row.column.card.p-3
      .row
        .column
          label Federation Name
            input(type="text", v-model="body.name")
      .row.column
        ActionButton(:action="save") Save
</template>

<script>
  import ActionButton from '../../components/structure/ui/ActionButton'
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'

  export default {
    name: 'FederationAdd',
    components: {ActionButton},
    data() {
      return {
        body: {
          name: null
        }
      }
    },
    methods: {
      save() {
        return KeplerBackofficeSdk.federations.make(this.body, (data) => {

          MaggieHelper.notification('Done', 'Federation created')
          this.$router.push({name: 'federations'})

        })
      }
    },
    props: []
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// FederationAdd.vue?0ecb5af6